import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    '& > div.MuiTextField-root': {
      width: '100%',
    },
  },
  loader: {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
  },
}));
